<template>
  <v-dialog max-width="300px" scrollable v-model="show">
    <v-card>
      <v-card-title>{{$t('app.labels.downloadAttach')}}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid style="padding:0px 18px !important;">
          <!-- <v-radio-group column v-model="category">
            <v-radio label="INV P/L" value="invoice"></v-radio>
            <v-radio label="B/L" value="bl"></v-radio>
            <v-radio label="S/A" value="sa"></v-radio>
            <v-radio label="A/N" value="an"></v-radio>
            <v-radio label="その他ファイル" value="other"></v-radio>
          </v-radio-group>-->
        </v-container>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-btn @click.native="download" color="blue darken-1" flat>{{$t('app.buttons.downloadNow')}}</v-btn>
        <v-btn @click.native="close" color="blue darken-1" flat>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['blNo'],
  data() {
    return {
      category: 'ar',
      show: false
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    close() {
      this.show = false
    },
    getKey() {
      return this.blNo
        .replace(new RegExp('/', 'g'), '_&_')
        .replace(/ /g, '_&_')
        .replace(/#/g, '_&_')
        .replace(/%/g, '_&_')
        .replace(/,/g, '_&_')
        .replace(/:/g, '_&_')
        .replace(/;/g, '_&_')
        .replace(/</g, '_&_')
        .replace(/=/g, '_&_')
        .replace(/>/g, '_&_')
        .replace(/@/g, '_&_')
    },
    download() {
      if (this.blNo && this.category) {
        this.$http.get(`/files/ar/${this.getKey()}/files`).then(res => {
          let files = res.data
          console.log(files)
          if (files.length > 0) {
            let file = files.sort((a, b) => {
              return b.uploadDate
                .toString()
                .localeCompare(a.uploadDate.toString())
            })[0]
            this.$download(`/files/ar/${this.getKey()}/files/${file.id}`)
          } else {
            this.$message('', 'アップロードデータ無し')
          }
        })
      }
    }
  }
}
</script>